import type {
    getGetToggledOutlooks,
    getGetOptions,
    getGetImportProperties,
    getResetBootAttempts,
    getLaunchLegacyApp,
    getLogToDisk,
    getGetOptionSettings,
    getSetOptionComplete,
    getSetToggleProgress,
    getAddProcessImportOptionsEventHandler,
    getRemoveProcessImportOptionsEventHandler,
} from '../lazyIndex';
import { LazyAction } from 'owa-bundling-light';
import { lazyModule } from '../lazyFunctions';

export const lazyGetGetToggledOutlooks: LazyAction<
    typeof getGetToggledOutlooks,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getGetToggledOutlooks);

export const lazyGetGetOptions: LazyAction<typeof getGetOptions, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getGetOptions);

export const lazyGetGetImportProperties: LazyAction<
    typeof getGetImportProperties,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getGetImportProperties);

export const lazyGetResetBootAttempts: LazyAction<typeof getResetBootAttempts, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getResetBootAttempts);

export const lazyGetLaunchLegacyApp: LazyAction<typeof getLaunchLegacyApp, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getLaunchLegacyApp);

export const lazyGetLogToDisk: LazyAction<typeof getLogToDisk, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.getLogToDisk
);

export const lazyGetGetOptionSettings: LazyAction<typeof getGetOptionSettings, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getGetOptionSettings);

export const lazyGetSetOptionComplete: LazyAction<typeof getSetOptionComplete, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getSetOptionComplete);

export const lazyGetSetToggleProgress: LazyAction<typeof getSetToggleProgress, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getSetToggleProgress);

export const lazyGetAddProcessImportOptionsEventHandler: LazyAction<
    typeof getAddProcessImportOptionsEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAddProcessImportOptionsEventHandler);

export const lazyGetRemoveProcessImportOptionsEventHandler: LazyAction<
    typeof getRemoveProcessImportOptionsEventHandler,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getRemoveProcessImportOptionsEventHandler);
